import { AttachmentEditing } from '../../types'
import NoPropertiesForm from '../NoPropertiesForm'
import MarkdownFileProperties from './components/MarkdownFileProperties'
import PDFFileInfo from './components/PDFFileInfo'
import ProjectDataForm from './components/ProjectDataForm'
import TOCForm from './components/TOCForm'
import TitlePageForm from './components/TitlePageForm'
import WordFileInfo from './components/WordFileInfo'

interface Props {
  file: FileItem
  debouncedFileConfigSave: (data: FileItemConfig) => void
  setCropConfig: (config: {
    croppedLeft: number
    croppedTop: number
    croppedRight: number
    croppedBottom: number
  }) => void
  attachmentEditing: AttachmentEditing
  /** Page count of the file shown in the viewer, if loaded */
  pageCount?: number
  onPagesChange?: (itemGuid: string, pages: number[] | null) => void
}

const FilePropertiesForm = ({
  file,
  debouncedFileConfigSave,
  setCropConfig,
  attachmentEditing,
  pageCount,
  onPagesChange,
}: Props) => {
  if (file.template_key === 'cover-page') {
    return <TitlePageForm item={file} mutate={debouncedFileConfigSave} />
  }

  if (file.template_key === 'toc') {
    return <TOCForm />
  }

  if (!file.template_key && file.mimetype === 'application/pdf') {
    return (
      <PDFFileInfo
        item={file}
        mutate={debouncedFileConfigSave}
        onCropConfigChange={setCropConfig}
        pageCount={pageCount}
        onPagesChange={onPagesChange}
      />
    )
  }

  if (
    !file.template_key &&
    (file.mimetype === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      file.mimetype === 'application/msword' ||
      file.mimetype === 'application/octet-stream')
  ) {
    return <WordFileInfo item={file} mutate={debouncedFileConfigSave} />
  }

  if (file.template_key === 'project-data') {
    return <ProjectDataForm item={file} mutate={debouncedFileConfigSave} />
  }

  if (file.template_key === 'markdown-page') {
    return (
      <MarkdownFileProperties
        item={file}
        mutate={debouncedFileConfigSave}
        attachmentEditing={attachmentEditing}
        onCropConfigChange={setCropConfig}
        pageCount={pageCount}
        onPagesChange={onPagesChange}
      />
    )
  }

  return <NoPropertiesForm item={file} mutate={debouncedFileConfigSave} />
}

export default FilePropertiesForm
